import { IProduct, ISimCard } from "../../fetchOrderProducts";

export function isSimCard(product: IProduct): product is ISimCard {
  return "specificationId" in product && product.specificationId === "SIM_CARD";
}
